import { render, staticRenderFns } from "./sjsltb.vue?vue&type=template&id=596c4ff1&scoped=true&"
import script from "./sjsltb.vue?vue&type=script&lang=js&"
export * from "./sjsltb.vue?vue&type=script&lang=js&"
import style0 from "./sjsltb.vue?vue&type=style&index=0&id=596c4ff1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596c4ff1",
  null
  
)

export default component.exports